import { CancelReservationSeriesModal } from './series/CancelReservationSeriesModal';
import { CancelReservationSingleModal } from './single/CancelReservationSingleModal';
import { CancelReservationModalProps, isSeriesModalProps } from './types';

export const CancelReservationModal = (
  props: CancelReservationModalProps
): JSX.Element =>
  isSeriesModalProps(props) ? (
    <CancelReservationSeriesModal {...props} />
  ) : (
    <CancelReservationSingleModal {...props} />
  );
